import { FC } from "react";

import { Stack } from "capitalrx-components-2.0/lib/layout";

import styles from "../NewNetworkPage/NewNetworkPage.module.scss";
import { PaymentRemittanceView } from "../../components/Account/Update/tabComponents/PaymentRemittance/PaymentRemittanceView";


export const ViewNetworkPage: FC = () => {

  return (
    <div className={styles.NewNetworkContainer}>
      <Stack spacing="large">
        <PaymentRemittanceView />
      </Stack>
    </div>
  );
};

export default ViewNetworkPage;
